"use strict";

import jQuery from 'jquery';

/**
 * @typedef gc.gis.widget.GCSelectOption
 * @type {Object}
 * @property {string} label Angezeigter Text
 * @property {*} value primitiver Wert
 * @property {Object} [data] Complex
 * @property {boolean} [default=false] Bei non-multiple
 * @property {boolean} [selected=false] Bei multiple
 * @property {boolean} [separator=false] Trennstrich
 */

/**
 * @classdesc
 * Auswahllisten-Element.
 *
 * @class
 * @extents gc.gis.widget.GCInput
 * @memberof gc.gis.widget
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 *
 * @param {gc.gis.widget.GCSelectOption[]} [options.options] Liste von Elementen.
 * @param {Function} [options.change] Funktion, die beim Ändern des Wertes der Auswahlliste im Kontext des
 *                  Eingabe-Elementsaufgerufen wird.
 */
gc.gis.widget.GCSelect = function(options)
{
	gc.gis.widget.GCInput.call(this, options);

	this._options       = options.options || [];
	this._change        = options.change;
	this._multiple      = options.multiple === true;
	this._size          = options.size || 5;
};
gc.gis.widget.GCSelect.prototype = Object.create(gc.gis.widget.GCInput.prototype);

/**
 * @inheritDoc
 */
gc.gis.widget.GCSelect.prototype.getValue = function()
{
	if (this._inputElement)
	{
		return this._inputElement.val();
	}

	return this._multiple ? [] : null;
};

/**
 * Liefert den Wert des Data-Attributs der aktuell gewählten Option, sofern diese mit einem Data-Value versehen wurde. Bei aktivierter
 * Mehrfachauswahl wird eine Liste von Data-Attributen gemäß Auswahl zurückgegeben. Siehe auch {gc.gis.widget.GCSelectOption[]}.
 *
 * @return {null|*|Array}
 */
gc.gis.widget.GCSelect.prototype.getDataForSelection = function()
{
	if (this._inputElement)
	{
		const selectedOptions = this._inputElement.find(':selected');

		if (!this._multiple)
		{
			return selectedOptions.data('__data');
		}

		const dataList = [];
		let data;
		selectedOptions.each(function () {
			data = jQuery(this).data('__data');
			if (data)
			{
				dataList.push(data);
			}
		});
		return dataList;
	}

	return this._multiple ? [] : null;
};

/**
 * Aktualisiert die Auswahloptionen der Auswahlliste.
 *
 * @public
 * @param {gc.gis.widget.GCSelectOption[]} options
 */
gc.gis.widget.GCSelect.prototype.updateOptions = function(options)
{
	let element_option;

	this._options = options;
	this._inputElement.children().remove();

	for (let i = 0, ii = options.length; i < ii; i++)
	{
		if (options[i].options)
		{
			element_option = jQuery('<optgroup label="">');
			if (options[i].label)
			{
				element_option.attr('label', options[i].label);
			}
			for (let j = 0, jj = options[i].options.length; j < jj; j++)
			{
				element_option.append(this._renderOption(options[i].options[j]));
			}
		}
		else
		{
			element_option = this._renderOption(options[i]);
		}

		this._inputElement.append(element_option);
	}
};

/**
 * @inheritdoc
 */
gc.gis.widget.GCSelect.prototype._renderOption = function(option)
{
	let element_option;

	if (option.separator === true)
	{
		element_option = jQuery('<option>', {
			disabled:  'disabled',
			class:     'separator'
		});
	}
	else
	{
		element_option = jQuery('<option>', {
			text:  option.label,
			value: option.value
		});
	}

	if ('' !== option.className)
	{
		element_option.addClass(option.className);
	}

	if (option.tooltip)
	{
		element_option.attr('title', option.tooltip);
	}

	if (option.disabled)
	{
		element_option.attr('disabled', true);
	}

	if (option.data)
	{
		element_option.data('__data', option.data);
	}

	if (option.selected || option.default)
	{
		element_option.attr('selected', true);
	}

	return element_option;
};

/**
 * @inheritdoc
 */
gc.gis.widget.GCSelect.prototype._renderInput = function()
{
	this._inputElement = jQuery('<select>', {
		'class': 'form-control control-select' + (this.inputClassName ? ' ' + this.inputClassName : '')
	});

	if (this._multiple)
	{
		this._inputElement.attr('multiple', true);
		this._inputElement.attr('size', this._size);
	}

	this.updateOptions(this._options);
	if (this.defaultValue)
	{
		this._inputElement.val(this.defaultValue);
	}

	// ggf. change-event anhängen
	if (typeof this._change === 'function')
	{
		const self = this;
		const fn = this._change;
		this._inputElement.on('change', function(evt) {
			evt.preventDefault();
			try
			{
				fn.call(self, evt, self);
			}
			catch(err)
			{
				gc.gis.iface.log.error(this, err);
			}
			jQuery(this).blur();
		});
	}

	return this._inputElement;
};